<ui-booking-wizard-body>
  <ui-booking-wizard-body-column>
    <markant-platform-contract-partner-info></markant-platform-contract-partner-info>
  </ui-booking-wizard-body-column>
  <ui-booking-wizard-body-column>
    <markant-platform-billing-info
      [bookingDataForm]="bookingDataForm"
      [bookingData]="bookingData"
      [submitted]="submitted"
    ></markant-platform-billing-info>
  </ui-booking-wizard-body-column>
  <ui-booking-wizard-body-column>
    <markant-platform-references-info
      [referencesForm]="bookingDataForm.controls.references"
    ></markant-platform-references-info>
  </ui-booking-wizard-body-column>
</ui-booking-wizard-body>
